/**
 * Copyright 2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import URLs from '../utilities/URLs';
import { getCookie } from './common';

export interface IUser {
  Id: string;
  Username: string;
  AccessToken: string;
}

export async function login (username: string, password: string): Promise<IUser> {
  const response = await fetch(URLs.getLogin(), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': getCookie('XSRF-TOKEN') || ''
    },
    body: JSON.stringify({ username: username, password: password})
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const data = await response.json();
  return data;
}

export async function logout () {
  const response = await fetch(URLs.getLogout(), {
    method: 'GET'
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }
}

export async function getUserinfo (): Promise<IUser | undefined> {
  const response = await fetch(URLs.getUserinfo(), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    return undefined;
  }

  const data = await response.json();
  return data;
}